<template>
  <SfHeader class="header">
    <div slot="logo">
      <img @click="logoClicked" class="logo" alt="Fêt'Art" :src="require('@/assets/img/logo1.png')" />
    </div>
    <div class="navigation" slot="navigation">
      <!-- <template #navigation id="2"> -->
      <SfHeaderNavigationItem v-for="(item,i) in navigation" :key="i">
        <a
          href="#"
          @click.prevent="()=>{$router.push(item.path)}"
          :style="{ display: 'flex', alignItems: 'center', jutifyContent:'flex-end', height: '100%', padding:'0 1rem 0 1rem' }"
        >{{ item.label }}</a>
      </SfHeaderNavigationItem>
    </div>
    <!-- </template> -->
    <span slot="search" style="position: absolute"></span>
    <div slot="header-icons" style="position: absolute"></div>
  </SfHeader>
</template>

<script>
import { SfHeader } from "@storefront-ui/vue";

export default {
  components: { SfHeader },
  data() {
    return {
      navigation: [
        { label: "Accueil", path: "/" },
        { label: "Boutique", path: "/category" }
      ]
    };
  },
  methods: {
    logoClicked() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" >
nav.sf-header__navigation.desktop-only {
  display: flex !important;
  margin: 0;
  height: auto;
}
</style>

<style lang="scss" scoped>
@import "~@storefront-ui/vue/styles.scss";

.navigation {
  display: flex;
  height: 50px;
  @media (min-width: 630px) {
    height: 110px;
  }
}
.header {
  display: flex;
  --header-container-height: auto;
  --header-sticky-container-width: 100%;
  --header-navigation-item-size: 20px;
  --header-container-justify-content: center;
  --header-navigation-item-margin: 0 var(--spacer-xl) 0 0;
  @media (min-width: 630px) {
    --header-container-justify-content: space-between;
  }

  .sf-header-navigation-item {
    --header-navigation-item-color: var(--c-primary);
    & :hover {
      $a: --c-primary;
      color: lighten(#ca0074, 10%);
    }
  }
}
.logo {
  cursor: pointer;
  height: 90px;
  padding: 10px 0 10px 0;

  @include for-desktop {
    padding: 5px 0 15px 20px;
    height: 90px;
    bottom: 5px;
    top: 0px;
  }
}
</style>